var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mg-less color-gray text-font-14"},[_vm._v(" © 2023 Indigy | All Rights Reserved ")])}
var staticRenderFns = []

export { render, staticRenderFns }